import { Button, Flex, Modal, Typography } from "antd"
import dayjs from "dayjs"

import Icon from "../../../Icon"

import "./LogsModal.less"

const { Text } = Typography

const LogsModal = ({ title, description, logs = [], open = false, onClose }) => {
  const getLogMessage = (log) => log?.log_message || log?.message || "-";

  const getLogTimestamp = (log) => {
    if (log?.timestamp) return log.timestamp;
    if (log?.created) return dayjs(log.created).format("DD MMM YYYY h:mm A [(UTC)]");
    return "-";
  };

  return (
    <div className="descriptor-logs">
      <Modal
        classNames={{ content: "clear-bg" }}
        open={open}
        getContainer={() => document.getElementById("main-layout")}
        closeIcon={<Icon type="cross_small" />}
        closable
        onCancel={onClose}
        destroyOnClose
        width={442}
        centered
        title={
          <Flex vertical gap={8}>
            <Text className="modal-title">{title}</Text>
            <Text type="secondary">{description}</Text>
          </Flex>
        }
        rootClassName="descriptor-logs-modal"
        footer={
          <Button size="large" type="primary" onClick={onClose}>
            Got it
          </Button>
        }
      >
        <Flex
          gap={12}
          vertical
          style={{
            maxHeight: "300px"
          }}
        >
          <div className="descriptor-logs-table">
            <div className="row header">
              <Text type="secondary" strong>
                Event
              </Text>
              <Text type="secondary" strong>
                Date and time{" "}
              </Text>
            </div>
            {logs.map((log, index) => (
              <div key={index} className="row">
                <Text strong>{getLogMessage(log)}</Text>
                <Text strong>{getLogTimestamp(log)}</Text>
              </div>
            ))}
          </div>
        </Flex>
      </Modal>
    </div>
  )
}

export default LogsModal
